import { UniqueId } from '..';

export enum DateRangeType {
  LAST_90_DAYS,
  LAST_30_DAYS,
  LAST_7_DAYS,
  CUSTOM,
}

export enum ReportStatuses {
  Finished = 'finished',
  Failed = 'failed',
  WaitingForProcessing = 'waiting-for-processing',
}

export interface DataApiReportStatus {
  id: UniqueId;
  submissionDate?: Date;
  processingStartedAt?: Date;
  processingEndedAt?: Date;
  status?: ReportStatuses;
  failureReason?: string;
  priority?: string;
  signedUrl?: string;
  systemId: UniqueId;
  environmentId: UniqueId;
}
